import React from 'react';

interface SelectInputProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  hasError?: boolean;
  registerProps?: Record<string, unknown>;
  children: React.ReactNode;
}

export default function SelectInput({
  hasError,
  registerProps,
  children,
  ...props
}: SelectInputProps) {
  return (
    <select
      className="w-full rounded-lg px-4 py-3 text-sm font-sans transition-all duration-150 outline-none appearance-none"
      style={{
        border: `1px solid ${hasError ? '#a34f42' : 'var(--input)'}`,
        backgroundColor: 'var(--card)',
        color: 'var(--foreground)',
        fontFamily: 'var(--font-sans)',
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23756d67' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 12px center',
        paddingRight: '40px',
      }}
      onFocus={(e) => {
        e.currentTarget.style.borderColor = 'var(--primary)';
        e.currentTarget.style.boxShadow = '0 0 0 3px rgba(155,107,77,0.12)';
      }}
      onBlur={(e) => {
        e.currentTarget.style.borderColor = hasError
          ? '#a34f42' :'var(--input)';
        e.currentTarget.style.boxShadow = 'none';
      }}
      {...registerProps}
      {...props}
    >
      {children}
    </select>
  );
}